
// const server = 'http://192.168.0.100/website_electronicos_API/php_mysql';
// const server = 'http://localhost/website_electronicos_API/php_mysql';
const server = 'https://facturacionelectronica.racolcomputers.com/apiWeb/php_mysql';

const DataAPI = {
    getLogin : async function (user:string, password:string) {
        let ruta = server+'/Procesos/getLogin.php';
        return post(ruta, { 
            'usuario' : user,
            'pass' : password,
            'mantener' : false
        });
    },
    validaLogin : async function (token:string) {
        let ruta = server+'/Procesos/checkLogin.php';
        return post(ruta, { 
            'token' : token
        });
    },
    getCompanyData : async function (token:string) {
        let ruta = server+'/Consultas/getCompanyData.php';
        return post(ruta, { 
            'token' : token
        });
    },
    getWorkingCompanies : async function (token:string) {
        let ruta = server+'/Consultas/getWorkingCompanies.php';
        return post(ruta, { 
            'token' : token
        });
    },getWorkingCompaniesCertList : async function (token:string) {
        let ruta = server+'/Consultas/getWorkingCompaniesCertList.php';
        return post(ruta, { 
            'token' : token
        });
    },getCertificates : async function (token:string) {
        let ruta = server+'/Consultas/getCertificates.php';
        return post(ruta, { 
            'token' : token
        });
    },
    getCompanyName: async function (token:string,id:number) {
        let ruta = server+'/Consultas/getCompanyName.php';
        return post(ruta, { 
            'token' : token,
            'id' : id
        });
    },
    getCompanyDocs: async function (token:string,companyID:number
            , fechaini: string, fechafin: string, tipoEcf: string
            , statusEcf: string, rnc: string, ecf: string
    ) {
        let ruta = server+'/Consultas/getCompanyDocs.php';
        return post(ruta, { 
            'token' : token,
            'companyId' : companyID,
            'fechaini' : fechaini,
            'fechafin' : fechafin,
            'tipoEcf' : tipoEcf,
            'status' : statusEcf,
            'rnc' : rnc,
            'ecf' : ecf 
        });
    },
    getDocMessages: async function (token:string,id:number) {
        let ruta = server+'/Consultas/getDocMessages.php';
        return post(ruta, { 
            'token' : token,
            'apiID' : id
        });
    },
    checkDocInfoDGIIServer: async function(companyID: number, API_ID: number) {
        // Utilizando el API de Facturacion electronica desde esta API
        let ruta = 'https://facturacionelectronica.racolcomputers.com/prod/api/dgii/processes/getDGII_DocInfo.php';
        return post(ruta, { 
            'codcia' : companyID,
            'API_ID' : API_ID
        });
    },
    saveClientCertificate: async function(token:string, dataEnvio: { id: number, creationDate:string, dueDate:string }) {
        // Utilizando el API de Facturacion electronica desde esta API
        let ruta = server+'/Procesos/saveClientCertificate.php';
        return post(ruta, { 
            'token' : token,
            'dataEnvio' : dataEnvio
        });
    },
    checkClientCertificate: async function(dataEnvio: FormData) {
        // Utilizando el API de Facturacion electronica desde esta API
        let ruta = server+'/Procesos/checkClientCertificate.php';
        return postFD(ruta, dataEnvio);
    },
    saveClientCertificateFile: async function(dataEnvio: FormData) {
        // Utilizando el API de Facturacion electronica desde esta API
        let ruta = server+'/Procesos/saveClientCertificateFD.php';
        return postFD(ruta, dataEnvio);
    },
    downloadClientDocument: async function(
        token:string, companyID: number, secuence:number, companyDoc:string, encf:string, 
        encftype_fls:string, complete:number
    ) {
        // Utilizando el API de Facturacion electronica desde esta API
        let ruta = server+'/Procesos/downloadecfXML.php';
        return post(ruta, { 
            'token' : token,
            'companyID' : companyID,
            'secuence' : secuence,
            'companyDoc' : companyDoc,
            'encf' : encf,
            'encftype_fls' : encftype_fls,
            'complete' : complete
        });
    },
}; 

async function fetchConTimeout(recurso: any, opciones: any) {
    const { timeout } = opciones;

    const controller = new AbortController();
    const id = setTimeout( () => { controller.abort( ) }, timeout );

    const response = await fetch(recurso, {
        ...opciones, signal: controller.signal
        , headers: {
            "Content-Type": "application/json",
        },
    });

    clearTimeout(id);

    return response;
}

async function post(ruta: any, data: any): Promise<any> {
    let retorno: any;
    try {
        const response = await postConTimeout(ruta, data, { timeout: 5000 });
        const json = await response.json();
        retorno = json;
        // console.error(retorno);
        return retorno;  
    } catch (error) {
        console.error(error);
        return retorno;
    }    
}

async function postFD(ruta: string, data: FormData): Promise<any> {
    let retorno: any;
    try {
        const response = await postConTimeoutFD(ruta, data, { timeout: 5000 });
        const json = await response.json();
        retorno = json;
        // console.error(retorno);
        return retorno;  
    } catch (error) {
        console.error(error);
        return retorno;
    }    
}

async function postSinCors(ruta: any, data: any): Promise<any> {
    let retorno: any;
    try {
        const response = await postConTimeoutSinCors(ruta, data, { timeout: 5000 });
        const json = await response.json();
        retorno = json;
        // console.error(retorno);
        return retorno;  
    } catch (error) {
        console.log(error);
        return retorno;
    }    
}

async function postConTimeout(recurso: any, data: any, opciones: any) {
    const { timeout } = opciones;

    const controller = new AbortController();
    const id = setTimeout( () => { controller.abort( ) }, timeout );

    // console.log(JSON.stringify({
    //     data
    // }));
    const response = await fetch(recurso, {
        method : 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }, body : JSON.stringify({
            data
        }) ,
        ...opciones, signal: controller.signal
    });

    clearTimeout(id);

    return response;
}

async function postConTimeoutFD(recurso: any, data: FormData, opciones: any) {
    const { timeout } = opciones;

    const controller = new AbortController();
    const id = setTimeout( () => { controller.abort( ) }, timeout );

    // console.log(JSON.stringify({
    //     data
    // }));
    const response = await fetch(recurso, {
        method : 'POST',
        body : data ,
        ...opciones, signal: controller.signal
    });

    clearTimeout(id);

    return response;
}

async function postConTimeoutSinCors(recurso: any, data: any, opciones: any) {
    const { timeout } = opciones;

    const controller = new AbortController();
    const id = setTimeout( () => { controller.abort( ) }, timeout );

    // console.log(JSON.stringify({
    //     data
    // }));
    const response = await fetch(recurso, {
        method : 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }, body : JSON.stringify({
            data
        }),
        ...opciones, signal: controller.signal
    });

    clearTimeout(id);

    return response;
}

export default DataAPI;